import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  vps: {
    titles: {
      connection: null,
      working: null,
      handbook: null,
    },
    articles: null,
  },

  monitoring: {
    titles: null,
    articles: null,
  },

  videos: null,
};

export const manualsSlice = createSlice({
  name: 'manuals',
  initialState,
  reducers: {
    setManualsVpsTitles: (state, action) => {
      state.vps.titles = action.payload;
    },
    setManualsVpsArticles: (state, action) => {
      state.vps.articles = action.payload;
    },

    setManualsMonitoringTitles: (state, action) => {
      state.monitoring.titles = action.payload;
    },
    setManualsMonitoringArticles: (state, action) => {
      state.monitoring.articles = action.payload;
    },

    setVideos: (state, action) => {
      state.videos = action.payload;
    },

    resetVpsManual: () => initialState,
  },
});

export const {
  setManualsVpsTitles,
  setManualsVpsArticles,

  setManualsMonitoringTitles,
  setManualsMonitoringArticles,

  setVideos,

  resetVpsManual,
} = manualsSlice.actions;

export default manualsSlice.reducer;
